import type { CallReadyAnswer, CallReadyAnswerStatus, CallReadyQuestionId } from './callReadyFindings';

export type CallReadySpokenState = Exclude<CallReadyAnswerStatus, 'reference'>;

/** v3: ready and partial answers lead directly; Open retains its explicit evidence limit. */
export const CALL_READY_SPOKEN_TEMPLATE_VERSION = 'call-ready-spoken-templates-v3' as const;

export const CALL_READY_QUESTION_IDS: readonly CallReadyQuestionId[] = [
  'project', 'workforce', 'staffing-model', 'resources', 'power-cooling-risks', 'infrastructure',
  'community-concerns', 'permanent-jobs', 'construction-jobs', 'workforce-wages',
  'comparables', 'fiscal', 'answer-basis',
];

export const CALL_READY_ANSWER_STATUSES: readonly CallReadySpokenState[] = [
  'ready', 'partial', 'unavailable', 'review-pending',
];

export const CALL_READY_SPOKEN_STATE_TEMPLATES: Readonly<Record<CallReadySpokenState, string>> = {
  ready: '{{summary}}',
  partial: '{{summary}}',
  unavailable: 'We do not yet have a defensible answer. {{summary}}',
  'review-pending': 'Spoken wording is withheld because the versioned copy policy has not passed.',
};

export function spokenTemplateCatalog(): Readonly<Record<CallReadyQuestionId, Readonly<Record<CallReadySpokenState, string>>>> {
  return Object.fromEntries(CALL_READY_QUESTION_IDS.map((questionId) => [
    questionId,
    Object.fromEntries(CALL_READY_ANSWER_STATUSES.map((status) => [
      status,
      CALL_READY_SPOKEN_STATE_TEMPLATES[status],
    ])),
  ])) as Record<CallReadyQuestionId, Record<CallReadySpokenState, string>>;
}
export function renderCallReadySpokenSummary(answer: CallReadyAnswer): string {
  if (answer.status === 'reference') return `Background reference. ${answer.summary}`;
  if (answer.status === 'unavailable' && answer.unavailableCause) {
    return `We do not yet have a defensible answer because the ${answer.unavailableCause}.`;
  }
  return CALL_READY_SPOKEN_STATE_TEMPLATES[answer.status].replace('{{summary}}', answer.summary);
}
